export var createTenantApi = function (baseUrl, http) {
    var url = "".concat(baseUrl);
    var tenantApi = {
        get: function () {
            return http.get("".concat(url), {});
        },
    };
    return tenantApi;
};
//# sourceMappingURL=index.js.map